import type { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import type { TranslationKey } from "../../../../../../localization/translations"

type Props = Readonly<{
    labelId: TranslationKey
    label: string
    children: ReactNode
}>

/** A dialog form field with its label above the control. */
export function LabeledDialogField({ labelId, label, children }: Props) {
    return (
        <Stack spacing=".375rem">
            <LocalizedStrict id={labelId}>
                <Typography variant="subtitle2">{label}</Typography>
            </LocalizedStrict>
            {children}
        </Stack>
    )
}
